import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { withRouter, Link } from "react-router-dom";
import axios from 'axios';
import Footer from 'components/Footer/Footer';
import './style.css';


import Button from 'react-bootstrap/Button';
//import { Image, Container, Row, Col, Card } from 'react-bootstrap';
//import banner_1 from "Assets/getonwithit/cop26graphicresources.002.jpeg";
//import banner_2 from "Assets/getonwithit/COP26_Graphic_Resources.004.jpeg";
//import david_banner from "Assets/getonwithit/COP26_Graphic_Resources.005.jpeg";
//import point_right_image from "Assets/getonwithit/COP26_Graphic_Resources.007.jpeg";

import banner_1 from "Assets/getonwithit/01-Header-Image.jpg";
import banner_2 from "Assets/getonwithit/02-Process.gif";
import banner_3 from "Assets/getonwithit/03-How-To.jpg";
import banner_4 from "Assets/getonwithit/04_Top-Tips-Animated.gif";
import banner_5 from "Assets/getonwithit/05_Share-With-World-Animated.gif";
import banner_6 from "Assets/getonwithit/06-David.jpg";

import SignupModal from 'components/Modals/SignupModal';
import VerificationModal from 'components/Modals/VerificationModal';

import { apiUrl, user_Status, user_Status_Ver } from 'Api/Api';

import { local_routes } from 'utils/Routes';

//import eventBanner from "Assets/internationalpk/sean_rules_2.png";

//import storytellingMadeEasyImg from "Assets/internationalpk/storytelling_made_easy_2021.png";
//import tellUsWhatYouLoveImg from "Assets/internationalpk/tell_us_what_you_love_2021.jpeg";
//import ipkLoveImg from "Assets/internationalpk/ipk2021_love.jpeg";

//import timetable_1 from "Assets/internationalpk/Timetable 3up 2 columns.001 (1).jpeg";
//import timetable_2 from "Assets/internationalpk/Timetable 3up 2 columns.002 (1).jpeg";


import home from 'Assets/home.svg';

import FullPageSpinner from 'components/FullPageSpinner/FullPageSpinner';

import UserContext from 'store/UserContext';

//const signup_link = "https://www.youtube.com/c/PechakuchaOrg/featured";
//const download_ipk_images_link = "https://bit.ly/international_pechakucha_day_2021_logos";

class GetOnWithIt extends Component {
    static contextType = UserContext;
    constructor(props) {
      super(props);
      
      this.state = {
        //getonwithit_channel_uuid: null,
        getonwithit_event_uuid: null,
        //loading: true,
        //saving: false,
        show_signup_modal: false,
        verification_modal_show: false,
        //presentation_name: '',
        //slide_image: null,
        //slide_image_name: '',
        //audioOutput: null, // returned from QuickCreatePresentation
        //language_abbreviation: 'en-US', // returned from QuickCreatePresentation
        //message: '',
        //audio_message: '',
        //validated: false,
        //waiting_for_video_presentation_uuid: ''
      };
      
      this.event_friendly_url = 'getonwithit';
      //this.channel_friendly_url = 'getonwithit-powered-by-pechakucha';
      
      this.event_link = '/events/getonwithit';
      
      this.button_text_color = '#FFFFFF';
      this.button_color = '#7b38e5';

      this.pageText = {
        pkmaker_button: 'Create your #GetOnWithIt Presentation!!!',
        //pkmaker_button: {
        //  'en-US': 'Create your #GetOnWithIt Presentation NOW!!',
        //  'ja-JP': 'Create your #GetOnWithIt Presentation NOW!!'
        //},
        //signup_now_button: {
        //  'en-US': 'Sign up now for #ipk2021',
        //  'ja-JP': '参加登録はこちら #ipk2021'
        //},
        intro_header: <span style={{ fontWeight: 'bolder', fontSize: 'larger' }}><p>It's time for action! It's time for PechaKucha! It's time to #GetOnWithIt!</p></span>,
        intro: <span>
          <p>
          This November, all eyes will be on Glasgow, Scotland for the UN Climate
          Change Conference(COP26). World Leaders and policymakers will come together to discuss
          how to tackle climate change together.
          </p><br/>
          <p>
          <a rel="noopener noreferrer" target='_blank' href="https://daydreambelievers.co.uk/">Daydream Believers</a>, in collaboration with <a target='_blank' href={this.event_link}>PechaKucha</a>, are creating a
          #GetOnWithIt Challenge and hosting a space in Glasgow during the COP26 for
          young people to share the ideas for better future and to demand from world
          leaders, policymakers, older generations and even your own parents to finally
          GET ON WITH IT and start saving our planet!
          </p><br/>
          <p>
          <a rel="noopener noreferrer" target='_blank' href="https://bit.ly/3mRekgg">Download the #GetOnWithIt Action pack</a> to help you come up with the
          ideas and your presentation, and once you’re ready, use PechaKucha Create
          tool to submit your ideas!
          </p>
        </span>,
        // intro: {
        //   'en-US': <span>
        //     For COP26 and through the <a target="_blank" rel="noopener noreferrer" href="https://drive.google.com/open?id=1dGWH1L7zujzE0MKVlNO0cTMsHA1h5twq&authuser=brian%40pechakucha.org&usp=drive_fs">#GetOnWithIt Challenge</a> you've been challenged to share your ideas for ways to get the attention of world leaders, policymakers, older generations and even your own parents to finally GET ON WITH IT and start saving our planet!
        //     <br/><br/>
        //     You've BRIEFED your idea. You've IDEATED it. You’ve CRAFTED it! Now it's time to PRESENT it ... With PechaKucha!
        //   </span>,
        //   'ja-JP': <span>
        //     For COP26 and through the #GetOnWithIt Challenge you've been challenged to share your ideas for ways to get the attention of world leaders, policymakers, older generations and even your own parents to finally GET ON WITH IT and start saving our planet!
        //     <br/><br/>
        //     You've BRIEFED your idea. You've IDEATED it. You’ve CRAFTED it! Now it's time to PRESENT it ... With PechaKucha!
        //   </span>
        // },
        what_is_pk_header: <span style={{ fontWeight: 'bolder' }}><p>So what is this PechaKucha format all about?!</p></span>,
        what_is_pk: <span>
          <p>PechaKucha means the sound of "Chit Chat" in Japanese and is a simple showand-tell format where you present your creative ideas in a format where images
          automatically advance every 20 seconds. This keeps presentations concise and
          powerful with every moment having IMPACT!</p><br/>
          <p>Depending on your preference, you can pick between several formats:<br/>
          10 images x 10 seconds each<br/>
          10 images x 20 seconds each<br/>
          20 images x 20 seconds each<br/>
          Or even 5 images x 5 seconds each for the very quick speakers.</p>
        </span>,
        // what_is_pk: {
        //   'en-US': <span>
        //     PechaKucha means the sound of "Chit Chat" in Japanese and is a simple show-and-tell format where you present your creative ideas in a format where images automatically advance every 20 seconds. This keeps presentations concise and powerful with every moment having IMPACT!
        //     <br/><br/>
        //     To make it easier for schools there are shorter formats like 10 images x 10 second and 10 images x 20 seconds which we would like you to use - but if you want to make a full blown 20x20 go for it!
        //   </span>,
        //   'ja-JP': <span>
        //     PechaKucha means the sound of "Chit Chat" in Japanese and is a simple show-and-tell format where you present your creative ideas in a format where images automatically advance every 20 seconds. This keeps presentations concise and powerful with every moment having IMPACT!
        //     <br/><br/>
        //     To make it easier for schools there are shorter formats like 10 images x 10 second and 10 images x 20 seconds which we would like you to use - but if you want to make a full blown 20x20 go for it!
        //   </span>
        // },
        how_to: 
          <span>
            <ul>
              <li>
                <span style={{ fontWeight: 'bolder' }}>Prepare & upload your images</span>
                <ul>
                  <li>Create 10 or 20 images by preparing them in PowerPoint, Keynote or any other image editing sowftware in 16:9 aspect ratio (min 1920x1080px), and export them as JPEG files.</li>
                  <li>Click the big purple button below and start uploading!</li>
                </ul>
              </li>
              <li>
                <span style={{ fontWeight: 'bolder' }}>Voice your images</span>
                <ul>
                  <li>Once your images are upload hit NEXT and you will be able to voice them - one by one - or as a complete recording.</li>
                  <li>Record and re-record as many times as you need!</li>
                </ul>
              </li>
              <li>
                <span style={{ fontWeight: 'bolder' }}>Tag and Share it</span>
                <ul>
                  <li>Make sure you add it to #GetOnWithIt category</li>
                  <li>The presentation will be visible on the #GetOnWithIt Presentation Page <a target='_blank' href={this.event_link}>here</a></li>
                </ul>
              </li>
            </ul>
          </span>
        ,
      
/*
Only use your first name
Please do not use any images that identify you or where you live
Use simple sketches, drawing and photographs to illustrate your idea
If you are using photo make sure they are your own or copyright free.
If you are using drawings etc you can get them into your presentation my just taking a digital photo of them from your phone!
Keep text to a minimum. Images are powerful - text is not! Remember you will be voicing them 
There are lots of great examples on PechaKucha.com just do a search for things you are interested in!
Remember to have fun and get excited about you are presenting about.
Check out these great tutorials about How to Make a PechaKucha Presentation and What Makes a PechaKucha Presentation Great! 
*/
        top_tips_header:
          <span style={{ fontWeight: 'bolder' }}><p>Top Tips:</p></span>,
        top_tips:
          <span>
            <ul>
              <li>If you are under 13, only use your first name when registering.</li>
              <li>Please do not use any images that identify you or where you live</li>
              <li>Use simple sketches, drawing and photographs to illustrate your idea</li>
              <li>If you are using photos make sure they are your own or copyright free.</li>
              <li>Keep text to a minimum. Images are powerful - text is not! Remember you will be voicing them</li>
              <li>There are lots of great examples on PechaKucha.com, just do a search for things you are interested in!</li>
              <li>Remember to have fun and get excited about what you are presenting about.</li>
              <li>Check out these great tutorials about <a target='_blank' href="/presentations/how-to-make-a-presentation-with-pechakucha-create">How to Make a PechaKucha Presentation</a> and <a target='_blank' href="/presentations/what-makes-a-great-pechakucha-presentation">What Makes a PechaKucha Presentation Great</a>!</li>
            </ul>
          </span>
        ,
        well_done: 
          <span>
             <p>Well done! We hope you enjoyed coming up with your ideas! We're excited to see what you came up with and show the world how amazing you all are and how passionate you are about saving our planet!</p><br/>
             <p>It is easy to share your presentations: Once published, please share with your friends, family, classmates, and teachers! Be sure to use #GetOnWithIt! The more we can get our message out the better!
             Encourage others to #GetOnWithIt and <Link onClick={this.checkUserEligible}>make a presentation with PK Create</Link>. Be sure to use #GetOnWithIt when sharing on social media!
             Together we can show the policymakers and the world that we will not stand for the empty promises and the only way forward is to ACT! Lets #GetOnWithIt!</p>
           </span>
        ,
        see_you:
          <span>
            See you on the world’s stage at Glasgow! The best presentations will be featured on PechaKucha.com and on the big screens at the festival site over the amazing 12-day event!
            We may even ask you to present LIVE via Zoom. Be a part of this great opportunity for you to show the world howto <span style={{ fontWeight: 'bolder' }}>#GetOnWithIt</span>.
          </span>
        ,
        // show_us_col_1: {
        //   'en-US': <span>
        //     Well done! We hope you enjoyed coming up with your ideas! We're excited to see what you came up with and show the world how amazing you all are and how passionate you are about saving our planet!
        //   </span>,
        //   'ja-JP': <span>
        //     Well done! We hope you enjoyed coming up with your ideas! We're excited to see what you came up with and show the world how amazing you all are and how passionate you are about saving our planet!
        //   </span>
        // },
        // show_us_col_2: {
        //   'en-US': <span>
        //     It is easy to share your presentations: Once published, please share with your friends, family, classmates, and teachers! Be sure to use #GetOnWithIt! The more we can get our message out the better!
        //   </span>,
        //   'ja-JP': <span>
        //     It is easy to share your presentations: Once published, please share with your friends, family, classmates, and teachers! Be sure to use #GetOnWithIt! The more we can get our message out the better!
        //   </span>
        // },
      };
    }
    
    async componentDidMount() {
      console.log("GetOnWithIt componentDidMount",window.localStorage.getItem('login_success_redirect_uri'));
      
      // get channel/event uuid
      let [event_response] = await Promise.all([
        //axios.get(`${apiUrl}channels/${this.channel_friendly_url}?attributes[0]=entity_uuid`),
        axios.get(`${apiUrl}events/${this.event_friendly_url}?attributes[0]=entity_uuid`),
      ]);
      
      this.setState({
        //getonwithit_channel_uuid: channel_response.data.entity_uuid,
        getonwithit_event_uuid: event_response.data.entity_uuid
      }, () => {
        // did we just login or verify? cool! do something
        const go_uri = window.localStorage.getItem('login_success_redirect_uri');
        window.localStorage.removeItem('login_success_redirect_uri');
        if (go_uri && user_Status_Ver === "1") {
          this.goPkCreate(go_uri);
        }
      });
      

      /*
      if (go_uri && user_Status_Ver === "1") {
        this.props.history.push({
          pathname: go_uri,
          data: {
            source: {
              entity_type: 'channels',
              entity_uuid: this.state.getonwithit_channel_uuid,
              submit_event_uuid: this.state.getonwithit_event_uuid,
              category_friendly_url_array: ['getonwithit'],
              referrer: '/getonwithit'
            }
          }
        });
      }
      */
    }
    
    goPkCreate = (go_uri) => {
      // need channel/event uuid
      this.props.history.push({
        pathname: go_uri,
        data: {
          source: {
            //entity_type: 'channels',
            //entity_uuid: this.state.getonwithit_channel_uuid,
            submit_event_uuid: this.state.getonwithit_event_uuid,
            category_friendly_url_array: ['getonwithit'],
            referrer: '/getonwithit'
          }
        }
      });
      
    }
    
    componentDidUpdate() {
      console.log("GetOnWithIt componentDidUpdate");
    }
    
    renderPkCreateButton = (button_text = this.pageText.pkmaker_button, onClickFunction = this.checkUserEligible) => {
      return (
        <React.Fragment>
            <Button
              //variant="danger"
              style={{ borderRadius: "12px", marginTop: "10px", marginBottom: "10px", color: this.button_text_color, backgroundColor: onClickFunction ? this.button_color : '#3CE000', borderColor: this.button_color }}
              size="lg"
              onClick={onClickFunction}
            >
              {button_text}
            </Button>
          
          <br/>
          
        </React.Fragment>
      );
    }
    
  checkUserEligible = (event) => {
    console.log("checkUserEligible",event);
    //if (!this.context.user_info.entity_uuid) {
    if (!user_Status) {
      console.error("NO user!");
      /*
      if (event && event.stopPropagation) {
        console.error("Stop propogation!");
        event.preventDefault();
        event.stopPropagation();
        if (event.target && event.target.blur) {
          event.target.blur();
        }
      }
      */
      //window.localStorage.setItem('loginOrigin',this.props.location.pathname);
      window.localStorage.setItem('login_success_redirect_uri',local_routes.pkcreation);
      this.setState({
        show_signup_modal: true
      });
      return false;
    }
    //if (this.context.user_info.status_code !== 1) {
    if (user_Status_Ver !== "1") {
      console.error("NO user is not verified!");
      window.localStorage.setItem('login_success_redirect_uri',local_routes.pkcreation);
        this.setState({
          verification_modal_show: true
        });
      return false;
    }
    
    // got verified user - make a PK!
    window.scrollTo(0, 0);
    this.goPkCreate(local_routes.pkcreation);
    //this.props.history.push(local_routes.pkcreation);
    //return true;
  }
  
  /*
  renderCardCols = () => {
    let cards = [];
    this.pageText.boxen.forEach((item) => {
      cards.push(
        <Col>
          <Card style={{ padding: '20px', height: '100px', textAlign: 'center', color: 'white', backgroundColor: this.button_color }}>
            {item.inner_text}
          </Card>
          <span style={{ fontSize: 'smaller' }}>{item.subtext}</span>
        </Col>
      );
    });
    return cards;
  }
  */
    
    render() {
        if (!this.context.user_info) {
          return (
              <FullPageSpinner />
          );
        }        
        
        return (
          <React.Fragment>
            <Helmet defer={false}>
              <title>Get On With It</title>
              <meta name="description" content="GIt's time for action! It's time for PechaKucha! It's time to #GetOnWithIt!" />
              <meta property="og:image" content={`https://www.pechakucha.com${banner_1}`} />
              <meta property="og:type" content="website" />
              <meta property="og:url" content="https://www.pechakucha.com/getonwithit" />
              <meta property="og:title" content="PechaKucha - Get On With It" />
              <meta property="og:description" content="It's time for action! It's time for PechaKucha! It's time to #GetOnWithIt!" />
            </Helmet>
            <div>
              <div style={{ marginTop: "5px" }}>
                <section className="banner-image-head-getonwithit" style={{ backgroundImage: `url( ${banner_1})`, backgroundColor: '#32FF00' }}>
                  <div className="container">
                  </div>
                </section>
              </div>
              
              <div className="container" style={{ maxWidth: '825px' }}>
                <div style={{ fontFamily: "Open Sans,sans-serif" }} className="getonwithit-text-section">
                  {this.pageText.intro_header}<br/>
                  {this.pageText.intro}<br/>
                  <center>
                    <a rel="noopener noreferrer" target='_blank' href="https://bit.ly/3mRekgg">
                      {this.renderPkCreateButton('Download the #GetOnWithIt Action Pack!!!',null)}
                    </a>
                  </center>
                </div>
              </div>
              
              <div style={{ marginTop: "5px" }}>
                <section className="banner-image-head-getonwithit" style={{ backgroundImage: `url( ${banner_2})` }}>
                  <div className="container">
                  </div>
                </section>
              </div>
              
              <div className="container" style={{ maxWidth: '825px' }}>
                <div style={{ fontFamily: "Open Sans,sans-serif" }} className="getonwithit-text-section">
                  {this.pageText.what_is_pk_header}<br/>
                  {this.pageText.what_is_pk}
                </div>
              </div>

              <div style={{ marginTop: "5px" }}>
                <section className="banner-image-head-getonwithit" style={{ backgroundImage: `url( ${banner_3})` }}>
                  <div className="container">
                  </div>
                </section>
              </div>

              <div className="container" style={{ maxWidth: '825px' }}>
                <div style={{ fontFamily: "Open Sans,sans-serif" }} className="getonwithit-text-section">
                  {this.pageText.how_to}
                  <center>
                    {this.renderPkCreateButton()}
                  </center>
                </div>
              </div>

              <div style={{ marginTop: "5px" }}>
                <section className="banner-image-head-getonwithit" style={{ backgroundImage: `url( ${banner_4})` }}>
                  <div className="container">
                  </div>
                </section>
              </div>
              
              <div className="container" style={{ maxWidth: '825px' }}>
                <div style={{ fontFamily: "Open Sans,sans-serif" }} className="getonwithit-text-section">
                  {this.pageText.top_tips_header}
                  {this.pageText.top_tips}
                </div>
              </div>
              
              <div style={{ marginTop: "5px" }}>
                <section className="banner-image-head-getonwithit" style={{ backgroundImage: `url( ${banner_5})` }}>
                  <div className="container">
                  </div>
                </section>
              </div>

              <div className="container" style={{ maxWidth: '825px' }}>
                <div style={{ fontFamily: "Open Sans,sans-serif" }} className="getonwithit-text-section">
                  <center>
                    {this.renderPkCreateButton()}
                  </center>
                  <br/>
                  {this.pageText.well_done}
                </div>
              </div>

              <div style={{ marginTop: "20px" }}>
                <section className="banner-image-head-getonwithit" style={{ backgroundImage: `url( ${banner_6})` }}>
                  <div className="container">
                  </div>
                </section>
              </div>
              
             <div className="container" style={{ maxWidth: '825px', marginTop: '10px' }}>
                <div style={{ fontFamily: "Open Sans,sans-serif" }} className="getonwithit-text-section">
                  {this.pageText.see_you}
                </div>
              </div>
              

              { !user_Status &&
                <SignupModal
                  show={this.state.show_signup_modal}
                  onHide={() => this.setState({show_signup_modal:false})}
                  reload={true}
                />
              }
        
              { user_Status_Ver !== "1" &&
                <VerificationModal
                  show={this.state.verification_modal_show}
                  onHide={() => this.setState({ verification_modal_show: false})}
                />
              }

              <Footer
                homeImg={home}
                homeImgRef="/"
                breadcrumbSubPage="Get On With It"
              />
            </div>
          </React.Fragment>
        );
    }
}

export default withRouter(GetOnWithIt);
